// import { createSlice, isAnyOf } from "@reduxjs/toolkit";
// import {
//   cancelSubscription,
//   getUserSubscription,
//   getSubscriptionPlans,
//   checkout,
//   retrieveSession,
//   upgradeSubscription,
//   refreshSubscriptionStatus,
// } from "../../services/subscriptionService";
// import toast from "../../utils/toast";

// const initialState = {
//   subscription: null,
//   cancelSubscription: null,
//   subscriptionPlans: null,
//   selectedPlan: null,
//   checkoutData: null,
//   retrieveSession: null,
//   upgradeData: null,
//   loading: false,
//   refreshing: false
// };

// const subscriptionSlice = createSlice({
//   name: "subscription",
//   initialState: initialState,
//   reducers: {
//     setSelectedPlan: (state, action) => {
//       state.selectedPlan = action?.payload;
//     },
//   },
//   extraReducers: (builder) => {
//     builder.addCase(getUserSubscription?.fulfilled, (state, action) => {
//       if (action?.payload?.success === true) {
//         state.subscription = action?.payload?.data[0];
//       } else {
//         toast.error(action?.payload?.message);
//       }
//       state.loading = false;
//     });

//     builder.addCase(cancelSubscription?.fulfilled, (state, action) => {
//       if (action?.payload?.success === true) {
//         state.cancelSubscription = action.payload.data;
//       } else {
//         toast.error(action?.payload?.message);
//       }
//       state.loading = false;
//     });

//     builder.addCase(getSubscriptionPlans?.fulfilled, (state, action) => {
//       if (action?.payload?.success === true) {
//         state.subscriptionPlans = action.payload.data;
//       } else {
//         toast.error(action?.payload?.message);
//       }
//       state.loading = false;
//     });

//     builder.addCase(checkout?.fulfilled, (state, action) => {
//       if (action?.payload?.success === true) {
//         state.checkoutData = action.payload.data;
//       } else {
//         toast.error(action?.payload?.message);
//       }
//       state.loading = false;
//     });

//     builder.addCase(retrieveSession?.fulfilled, (state, action) => {
//       if (action?.payload?.success === true) {
//         state.retrieveSession = action.payload.data;
//       } else {
//         toast.error(action?.payload?.message);
//       }
//       state.loading = false;
//     });

//     builder.addCase(upgradeSubscription?.fulfilled, (state, action) => {
//       if (action?.payload?.success === true) {
//         state.upgradeData = action.payload.data;
//         toast.success("Subscription upgraded successfully!");
//       } else {
//         toast.error(action?.payload?.message);
//       }
//       state.loading = false;
//     });

//     builder.addCase(refreshSubscriptionStatus?.fulfilled, (state, action) => {
//       if (action?.payload?.success === true) {
//         state.subscription = action?.payload?.data[0];
//         toast.success("Subscription activated successfully!");
//       } else {
//         // Don't show error for refresh failures, just log
//         console.log("Subscription refresh failed:", action?.payload?.message);
//       }
//       state.refreshing = false;
//     });

//     builder
//       .addMatcher(
//         isAnyOf(
//           cancelSubscription?.pending,
//           getUserSubscription?.pending,
//           getSubscriptionPlans?.pending,
//           checkout?.pending,
//           retrieveSession?.pending,
//           upgradeSubscription?.pending
//         ),
//         (state) => {
//           state.loading = true;
//         }
//       )
//       .addMatcher(
//         isAnyOf(refreshSubscriptionStatus?.pending),
//         (state) => {
//           state.refreshing = true;
//         }
//       )
//       .addMatcher(
//         isAnyOf(
//           cancelSubscription?.rejected,
//           getUserSubscription?.rejected,
//           getSubscriptionPlans?.rejected,
//           checkout?.rejected,
//           retrieveSession?.rejected,
//           upgradeSubscription?.rejected
//         ),
//         (state, action) => {
//           state.loading = false;
//           toast.error(action?.payload?.message);
//         }
//       )
//       .addMatcher(
//         isAnyOf(refreshSubscriptionStatus?.rejected),
//         (state, action) => {
//           state.refreshing = false;
//           console.log("Subscription refresh failed:", action?.payload?.message);
//         }
//       );
//   },
// });

// export const { setSelectedPlan } = subscriptionSlice?.actions;
// export default subscriptionSlice?.reducer;
import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  cancelSubscription,
  getUserSubscription,
  getSubscriptionPlans,
  checkout,
  retrieveSession,
  upgradeSubscription,
  refreshSubscriptionStatus,
  renewSubscription, 
  renewSubscriptionFromReminder,
} from "../../services/subscriptionService";
import toast from "../../utils/toast";

const initialState = {
  subscription: null,
  cancelSubscription: null,
  subscriptionPlans: null,
  selectedPlan: null,
  checkoutData: null,
  retrieveSession: null,
  upgradeData: null,
  renewData: null,
  reminderRenewData: null,
  loading: false,
  refreshing: false,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setSelectedPlan: (state, action) => {
      state.selectedPlan = action?.payload;
    },
  },
  extraReducers: (builder) => {
  
    builder.addCase(getUserSubscription.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.subscription = action?.payload?.data[0];
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

 
    builder.addCase(cancelSubscription.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.cancelSubscription = action.payload.data;
        toast.success("Subscription cancelled successfully!");
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });


    builder.addCase(getSubscriptionPlans.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.subscriptionPlans = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });


    builder.addCase(checkout.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.checkoutData = action.payload.data;
      } else {
        // Don't show error toast for checkout failures - let the component handle it
        console.log("Checkout failed:", action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(retrieveSession.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.retrieveSession = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(upgradeSubscription.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.upgradeData = action.payload.data;
        toast.success("Subscription upgraded successfully!");
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(renewSubscription.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.renewData = action.payload.data;
        toast.success("Subscription renewed successfully!");
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(renewSubscriptionFromReminder.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.reminderRenewData = action.payload.data;
        toast.success("Renewal started successfully!");
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(refreshSubscriptionStatus.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.subscription = action?.payload?.data[0];
        toast.success("Subscription activated successfully!");
      } else {
        console.log("Subscription refresh failed:", action?.payload?.message);
      }
      state.refreshing = false;
    });

    builder
      .addMatcher(
        isAnyOf(
          cancelSubscription.pending,
          getUserSubscription.pending,
          getSubscriptionPlans.pending,
          checkout.pending,
          retrieveSession.pending,
          upgradeSubscription.pending,
          renewSubscription.pending,
          renewSubscriptionFromReminder.pending
        ),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        isAnyOf(refreshSubscriptionStatus.pending),
        (state) => {
          state.refreshing = true;
        }
      )
  
      .addMatcher(
        isAnyOf(
          cancelSubscription.rejected,
          getUserSubscription.rejected,
          getSubscriptionPlans.rejected,
          retrieveSession.rejected,
          upgradeSubscription.rejected,
          renewSubscription.rejected,
          renewSubscriptionFromReminder.rejected
        ),
        (state, action) => {
          state.loading = false;
          toast.error(action?.payload?.message || "Something went wrong!");
        }
      )
      .addMatcher(
        isAnyOf(checkout.rejected),
        (state, action) => {
          state.loading = false;
          // Don't show error toast for checkout rejections - let the component handle it
          console.log("Checkout rejected:", action?.payload?.message);
        }
      )
      .addMatcher(
        isAnyOf(refreshSubscriptionStatus.rejected),
        (state, action) => {
          state.refreshing = false;
          console.log("Subscription refresh failed:", action?.payload?.message);
        }
      );
  },
});

export const { setSelectedPlan } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
